import React from 'react';
import { ProductSection } from '../ProductSection';
// todo: remove
// eslint-disable-next-line import/no-cycle
import Bucket from '../Bucket';

// todo: remove ignores
const renderers = {
  // eslint-disable-next-line react/display-name
  JoinBucket: (bucket, setRootBucket, rootBucket, offerData) => (
    <Bucket
      key={bucket.bucketId}
      bucket={bucket}
      setRootBucket={setRootBucket}
      rootBucket={rootBucket}
      offerData={offerData}
    />
  ),
  // eslint-disable-next-line react/display-name
  ProductBucket: (
    bucket,
    setRootBucket,
    rootBucket,
    offerData,
    setIsFieldErrorEnabled
  ) => (
    <ProductSection
      key={bucket.bucketId}
      setRootBucket={setRootBucket}
      bucket={bucket}
      rootBucket={rootBucket}
      offerData={offerData}
      setIsFieldErrorEnabled={setIsFieldErrorEnabled}
    />
  ),
  // eslint-disable-next-line react/display-name
  ProductFamilyBucket: (
    bucket,
    setRootBucket,
    rootBucket,
    offerData,
    setIsFieldErrorEnabled
  ) => (
    <ProductSection
      key={bucket.bucketId}
      setRootBucket={setRootBucket}
      bucket={bucket}
      rootBucket={rootBucket}
      offerData={offerData}
      setIsFieldErrorEnabled={setIsFieldErrorEnabled}
    />
  ),
  // eslint-disable-next-line react/display-name
  Bucket: (
    bucket,
    setRootBucket,
    rootBucket,
    offerData,
    setIsFieldErrorEnabled
  ) => (
    <ProductSection
      setRootBucket={setRootBucket}
      bucket={bucket}
      rootBucket={rootBucket}
      offerData={offerData}
      setIsFieldErrorEnabled={setIsFieldErrorEnabled}
    />
  )
};

export default renderers;
